export const getReleaseTime = (ReleaseDate) => {
  const nowDate = new Date().getTime();
  let minutes = 0;
  let hours = 0;
  let days = 0;
  const rDate = new Date(ReleaseDate).getTime();
  if (rDate > nowDate) {
    const diff = Math.abs(rDate - nowDate) / 1000;
    minutes = Math.floor(diff / 60) % 60;
    hours = Math.floor(diff / 3600) % 24;
    days = Math.floor(diff / 86400);
  }
  return { minutes, hours, days };
};
